import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { TProductCode } from '@/shared/types/deprecated-types'

type TFavoritesState = {
	items: TProductCode[]
}
const initialState: TFavoritesState = {
	items: []
}

const favorites = createSlice({
	name: `favorites`,
	initialState,
	reducers: {
		addToFavorites: (state: TFavoritesState, action: PayloadAction<TProductCode>) => {
			if (!state.items.includes(action.payload)) {
				state.items = [...state.items, action.payload]
			}
		},
		removeFromFavorites: (state: TFavoritesState, action: PayloadAction<TProductCode>) => {
			state.items = state.items.filter(item => item !== action.payload)
		}
	}
})

export const { addToFavorites, removeFromFavorites } = favorites.actions
export default favorites.reducer
